import React, { useEffect, useState } from 'react';

import { ToastContainer, toast } from "react-toastify";
import { SaveHeaderTypes, UpdateHeaderTypes, getAllArea, saveArea, updateArea } from '../../../../services/CommonService';
import { MultiSelect } from 'react-multi-select-component';


const AddHeaderTypes = ({ tenantprop, updateprop }) => {
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const fields = {
        name: '',
        status: '',
        tenantid: tenantprop.tenantid,
        tenant: tenantprop,
        area: []



    }

    const errors = {
        name: '',
        status: '',



    }

    const [errorFields, setErrorFields] = useState(errors);
    const [formfields, setFromFields] = useState(fields);
    const [areaList, setAreaList] = useState([])
    const [college, setCollege] = useState([])


    useEffect(() => {
        getAreas()
        setFieldData();


    }, []);



    const { name, status } = formfields;

    const setFieldData = async () => {
        if (updateprop?.id) {
            setFromFields(updateprop);
            setCollege(updateprop.area)

        }
    }


    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;



        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter header type .";
        }
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }
        // if (!fields["strtype"]) {
        //     formIsValid = false;
        //     errors["strtype"] = "*Please select .";
        // }


        setErrorFields(errors)
        return formIsValid;

    }

    const submitForm = async () => {
        console.log(formfields);
        const isValid = await validateForm();
        if (isValid) {
            formfields.area = college;
            if (!formfields.id) {
                //save
                const Response = await SaveHeaderTypes(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    formfields.id = Response.data.id;
                }

            } else {
                //update
                const Response = await UpdateHeaderTypes(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    formfields.id = Response.data.id;
                }
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }

    const getAreas = async () => {

        const reqdata = {
            pageno: '-1',
            query: {
                status: 'Active',
                tenantid: tenantprop.tenantid,
            }
        }


        const Response = await getAllArea(reqdata)
        let counter = 0;
        const rowdata = [];
        await Response.data.reduce(async (promise, res) => {
            await promise;
            const opts = {
                label: res.name,
                value: res.id
            }
            rowdata.push(opts);
            if (counter == Response.data.length - 1) {

                setAreaList(rowdata)
            }
            counter++;
        }, Promise.resolve());

    }

    return (<>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Tenant Name
            </label>
            <div className="col-lg-6">
                <b> {tenantprop.name} </b>

            </div>
        </div>


        <br />

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                College
            </label>
            <div className="col-lg-6">
                <MultiSelect
                    options={areaList}
                    value={college}
                    onChange={setCollege}
                    labelledBy="Select"
                />

            </div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Type
            </label>
            <div className="col-lg-6">
                <select
                    className="form-control" name='name'
                    onChange={handleChange} value={name}>
                    <option value="">Select </option>
                    <option value="Students">Students</option>
                    <option value="Professionals">Professionals</option>
                    <option value="Freshers">Freshers</option>
                    <option value="Academic Subjects">Academic Subjects</option>
                    <option value="Technical Courses">Technical Courses</option>
                    <option value="CRT">CRT</option>
                    <option value="Employability skills">Employability skills</option>
                    <option value="Coding Practice">Coding Practice</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.type}</div>
        </div>


        {/* <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Constituency / College Name
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="Constituency name"
                    name="name"
                    className="form-control"

                    value={name} maxLength={50} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.name}</div>
        </div> */}


        <br />

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Status
            </label>
            <div className="col-lg-6">
                <select
                    className="form-control" name='status'
                    onChange={handleChange} value={status}>
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.status}</div>
        </div>



        <br />
        <div className="form-group">
            <button onClick={submitForm} className="btn btn-primary" type="button"
            >Save</button>
        </div>

    </>)
}
export default AddHeaderTypes;